<p-tree
    *ngIf="items.length > 0"
    [value]="items"
    [(selection)]="selection"
    (selectionChange)="selectionChange.emit($event)"
    [selectionMode]="selectionMode"
    [filter]="filterMode"
    [propagateSelectionUp]="propagateSelectionUp"
    [propagateSelectionDown]="propagateSelectionDown"
    [expandedIcon]="expandedIcon"
    [collapsedIcon]="collapsedIcon"
    (onNodeSelect)="nodeSelect.emit($event)"
    (onNodeUnselect)="nodeUnselect.emit($event)"
    (onNodeExpand)="nodeExpand.emit($event)"
    (onNodeCollapse)="nodeCollapse.emit($event)"
    [styleClass]="styleClass"
    [ngClass]="{
        'agilityCheckbox': style === treeListTypesEnum.normal,
        'socialCheckbox': style === treeListTypesEnum.social,
        'agpr-treeList-hideParentCheckbox':  hideParentCheckbox
    }"
>
    <ng-template let-lockedItem pTemplate="locked">
        <span
            role="img"
            class="fa-regular fa-duotone fa-lock agpr-locked-icon"
            [agprTooltip]="lockMessage"
        ></span>
        <span
            class="agpr-locked-label"
            [pTooltip]="lockMessage | localize"
        >
            {{ lockedItem.label }}
        </span>
    </ng-template>

    <ng-template let-node [pTemplate]="templateDataType?.type">
        <div class="agpr-treeList-itemContainer">
            @if (filterString?.length > 0) {
                <span
                    class="agpr-treeList-itemLabel"
                    [pTooltip]="templateDataType?.useTooltip === false ? node.label : node.data.tooltip"
                    tooltipPosition="top"
                    [innerHTML]="node.label | highlight:filterString:undefined:undefined:false:true"
                ></span>
            } @else {
                <span
                    class="agpr-treeList-itemLabel"
                    [pTooltip]="templateDataType?.useTooltip === false ? node.label : node.data.tooltip"
                    tooltipPosition="top"
                >
                    {{ node.label }}
                </span>
            }

            @if (node.children && templateDataType?.type === 'Discover.dialogs.browsers.subject.header') {
                <span class="agpr-treeList-childCount">
                    ({{ node.children.length }})
                </span>
            }
        </div>
    </ng-template>

    <ng-template let-node pTemplate="count">
        <div class="agpr-treeList-itemContainer">
            <span
                [attr.aria-label]="node.label"
                [pTooltip]="showCountTooltip ? (node.label | localize) : null"
            >
                {{ node.label | localize }}
            </span>

            @if (node.data?.count >= 0) {
                <span [pTooltip]="node.data?.count | number">
                    {{ node.data.count | significantDigits }}
                </span>
            }
        </div>
    </ng-template>

    <ng-template let-node pTemplate="Subject">
        <div class="agpr-treeList-itemContainer">
            <span
                class="agpr-treeList-itemLabel"
                [attr.aria-label]="node.label"
                [pTooltip]="node.label | localize"
            >
                {{ node.label | localize }}
            </span>
            @if (node.children) {
                <span class="agpr-treeList-itemCount">
                    ({{ node.children.length }})
                </span>
            }
        </div>
    </ng-template>

    <ng-content></ng-content>
</p-tree>

@if (items.length === 0 && templateDataType) {
    <agpr-message
        class="agpr-treeList-noContent"
        [severity]="messageSeverityEnum.noContent"
    >
        <span>
            {{ templateDataType.noResultsLocalizationString | localize: { type: templateDataType.type } }}
        </span>
    </agpr-message>
}
